export const LIVING_EXPERIENCE_FIELDS = [
  { key: "noiseLevel", label: "🔊 Noise Level" },
  { key: "neighborBehavior", label: "🤝 Neighbor Behavior" },
  { key: "safety", label: "🛡️ Safety" },
  { key: "buildingCulture", label: "🏢 Building Culture" },
  { key: "parking", label: "🚗 Parking" },
  { key: "sharedSpaces", label: "🛋️ Shared Spaces" },
];

export const REVIEW_SAFETY_WARNING =
  "Keep reviews factual, neutral, and based on your own rental experience. Do not include accusations, insults, threats, protected-class references, medical claims, criminal claims, or unsupported statements.";
export const REVIEW_COOLDOWN_DAYS = 180;
export const REVIEW_COOLDOWN_MS = REVIEW_COOLDOWN_DAYS * 24 * 60 * 60 * 1000;
export const REVIEW_COOLDOWN_PERSON_MESSAGE =
  "You can leave an updated review for this person after 180 days.";
export const REVIEW_COOLDOWN_PROPERTY_MESSAGE =
  "You can leave an updated review for this property after 180 days.";

export const RENTDUO_AI_QUICK_PROMPTS = [
  "How do I leave a verified review?",
  "What should I check before renting this apartment?",
  "What are red flags in a lease?",
  "How do I respond professionally to this tenant?",
  "What documents should I verify?",
  "What does this review mean?",
  "Summarize this property history",
  "Explain NJ tenant rights",
  "Help me write a landlord response",
  "How do I pin my apartment?",
  "How do I claim a property?",
  "How do verification badges work?",
  "Help me complete my profile",
];

export const RENTDUO_AI_FEATURED_PROMPTS = [
  { label: "Verified review", prompt: "How do I leave a verified review?" },
  { label: "Lease red flags", prompt: "What are red flags in a lease?" },
  { label: "Help with profile", prompt: "Help me complete my profile" },
];

export const RENTDUO_AI_SUGGESTED_PROMPTS = RENTDUO_AI_QUICK_PROMPTS.filter(
  (prompt) => !RENTDUO_AI_FEATURED_PROMPTS.some((item) => item.prompt === prompt)
);

export const RENTDUO_AI_FEED_CARDS = [
  {
    id: "verified-review-tip",
    label: "AI Rental Tip",
    title: "Make verified reviews easier to trust",
    text: "Write from direct rental experience, include dates or context when useful, and avoid claims you cannot personally support.",
    action: "Ask about verified reviews",
    prompt: "How do I leave a verified review?",
  },
  {
    id: "lease-red-flags",
    label: "AI Lease Red Flag",
    title: "Watch for vague fees before signing",
    text: "If a lease mentions fees without clear amounts, timing, or refund rules, ask for the details in writing before you commit.",
    action: "Ask about lease red flags",
    prompt: "What are red flags in a lease?",
  },
  {
    id: "property-history",
    label: "AI Property Insight",
    title: "Property history is strongest with patterns",
    text: "One review is a signal, but repeated comments about maintenance, noise, deposits, or communication deserve closer attention.",
    action: "Summarize property history",
    prompt: "Summarize this property history",
  },
  {
    id: "professional-response",
    label: "RentDuo AI",
    title: "Keep rental replies calm and specific",
    text: "When responding to a tenant or landlord, address the issue, avoid personal attacks, and offer the next practical step.",
    action: "Help write a response",
    prompt: "Help me write a landlord response",
  },
];

export const RENTAL_FEEDBACK_DEFAULT = {
  rentalRelationship: "",
  rentalAgreement: "",
  paymentHistory: "",
  propertyCondition: "",
  leaseCompliance: "",
  communication: "",
  wouldRentAgain: "",
};

export const RENTAL_FEEDBACK_OPTIONS = {
  rentalRelationship: [
    "I was the landlord/property manager",
    "I was the tenant",
    "Other",
  ],
  rentalAgreement: ["Yes", "No", "Prefer not to say"],
  paymentHistory: [
    "Always on time",
    "Occasionally late",
    "Frequently late",
    "Unpaid balance reported",
    "Not applicable",
  ],
  propertyCondition: [
    "Good condition",
    "Normal wear and tear",
    "Minor damage reported",
    "Significant damage reported",
    "Not applicable",
  ],
  leaseCompliance: [
    "No issues reported",
    "Minor lease issues reported",
    "Repeated lease issues reported",
    "Major lease issue reported",
    "Not applicable",
  ],
  communication: [
    "Professional/responsive",
    "Mixed",
    "Difficult to reach",
    "Not applicable",
  ],
  wouldRentAgain: ["Yes", "Maybe", "No"],
};

export const BLOCKED_REVIEW_PATTERNS = [
  /\bcriminal\b/i,
  /\bfelon\b/i,
  /\bfraud\b/i,
  /\bscam(mer|med|ming)?\b/i,
  /\bstole\b/i,
  /\bthief\b/i,
  /\bdrugs?\b/i,
  /\baddict\b/i,
  /\bmental\b/i,
  /\bcrazy\b/i,
  /\bpsycho\b/i,
  /\bviolent\b/i,
  /\bassault\b/i,
  /\barrest(ed)?\b/i,
  /\billegal\b/i,
  /\bdisability\b/i,
  /\brace\b/i,
  /\breligion\b/i,
  /\bpregnan(t|cy)\b/i,
  /\bsex\b/i,
  /\bthreat(en|ened)?\b/i,
  /\bkill\b/i,
  /\bharass\b/i,
  /\bblacklist\b/i,
];
